/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Empty } from '../../models/empty';

export interface PutReleaseDelayedOrder$Params {
  'Active-Tenant-Identifier': string;
  aggregatorId: string;
  orderId: string;
}

export function putReleaseDelayedOrder(http: HttpClient, rootUrl: string, params: PutReleaseDelayedOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: Empty;
}>> {
  const rb = new RequestBuilder(rootUrl, putReleaseDelayedOrder.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('aggregatorId', params.aggregatorId, {});
    rb.path('orderId', params.orderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: Empty;
      }>;
    })
  );
}

putReleaseDelayedOrder.PATH = '/aggregators/{aggregatorId}/orders/{orderId}/release';
